module.exports = __webpack_public_path__ + "static/media/share-icon.cfa3fa51.svg";